export default __webpack_public_path__ + "static/news2-2-8227a90afbf158684c8664d10e329c48.jpg";